import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';
const buttonVariants = cva('inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-semibold transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0', {
    variants: {
        variant: {
            default: 'bg-primary text-primary-foreground shadow-premium hover:bg-primary/90 active:scale-[0.98]',
            accent: 'bg-accent text-accent-foreground shadow-premium hover:brightness-105 active:scale-[0.98]',
            outline: 'border border-border bg-background hover:bg-muted hover:border-primary/40 text-foreground',
            ghost: 'hover:bg-muted text-foreground',
            subtle: 'bg-muted text-foreground hover:bg-muted/70',
            destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
            link: 'text-primary underline-offset-4 hover:underline',
        },
        size: {
            default: 'h-10 px-4 py-2',
            sm: 'h-8 px-3 text-xs',
            lg: 'h-11 px-6 text-base',
            icon: 'h-9 w-9',
        },
    },
    defaultVariants: { variant: 'default', size: 'default' },
});
export const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (_jsx(Comp, { ref: ref, className: cn(buttonVariants({ variant, size, className })), ...props }));
});
Button.displayName = 'Button';
export { buttonVariants };
